import { render, staticRenderFns } from "./refresh.vue?vue&type=template&id=055ce8a8&scoped=true"
import script from "./refresh.vue?vue&type=script&lang=js"
export * from "./refresh.vue?vue&type=script&lang=js"
import style0 from "./refresh.vue?vue&type=style&index=0&id=055ce8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ce8a8",
  null
  
)

export default component.exports